import { Component, Input } from '@angular/core';
import { NgFor, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio'; // use module for standalone
import { SimpleSortByInterface, SortByInterface } from "@interfaces/components/sortBy.interface";

@Component({
  selector: 'app-sort-by',
  templateUrl: './sort-by.component.html',
  styleUrls: ['./sort-by.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    FormsModule,
    NgFor,
    TranslateModule,
    MatRadioModule,
  ],
})
export class SortByComponent {
  // base options (do not mutate these objects)
  sorting: Array<SortByInterface> = [
    { id: 1, direction: 'ASC',  sort: 'PRIORITY', text: 'popularity' },
    { id: 2, direction: 'DESC', sort: 'PRICE',    text: 'desc_price' },
    { id: 3, direction: 'ASC',  sort: 'PRICE',    text: 'asc_price' }
  ];

  // keep selectedId separate from the items in array
  selectedId!: number;
  sortBy!: SortByInterface; // current selected (clone)
  sortByDefault!: SortByInterface; // current selected (clone)

  // set default sorting by cloning matched item (do not hold reference)
  @Input() set defaultSorting(defaultSorting: SimpleSortByInterface) {
    const matched = this.sorting.find(e =>
      e.sort === defaultSorting.sort && e.direction === defaultSorting.direction
    );
    const chosen = matched ?? this.sorting[0];
    this.selectedId = chosen.id;
    this.sortBy = { ...chosen }; // clone to avoid mutating original array
    this.sortByDefault = { ...chosen }; // clone to avoid mutating original array
  }
  @Input() fromAllFiltration = false;

  @Input() set sortingForShops(data: boolean) {
    if (!data) return;
    // Change a copy or adjust logic — DO NOT mutate original objects
    // If you need to change the first option, replace the item with a new object:
    this.sorting = [
      { id: this.sorting[0].id, sort: 'AVERAGE_RATE', direction: 'DESC', text: this.sorting[0].text },
      ...this.sorting.slice(1)
    ];
    // if selectedId points to the changed item, update the clone
    const current = this.sorting.find(i => i.id === this.selectedId);
    if (current) this.sortBy = { ...current };
  }


  onSortChange(newId: number) {
    // find the item (from array) and clone it to current selection
    const found = this.sorting.find(i => i.id === newId);
    if (!found) return;

    this.selectedId = newId;
    this.sortBy = { ...found }; // clone to avoid modifying array item
  }
}
